import React, { useState, useEffect, useRef } from "react";

// import { Chart } from "chart.js";
import { Pie, getElementAtEvent } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useTranslation } from "react-i18next";
import ReportsDiamondService from "../../services/reports-Diamond.service";
import GlobalDiamondReportService from "../../services/reports-globalDiamond-service";
import logoImg from "../../assets/images/logo-img.png";
import { useSelector } from "react-redux";
import moment from "moment";
import { BlobToDownloadFile } from "../../helper/commanFunction";
import { Button, DatePicker, Select, Spin, Table, Tooltip } from "antd";
import Chart from "react-google-charts";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { chartColors } from "../reports/colors";

const { RangePicker } = DatePicker;
const { Option } = Select;

// Chart.register(ChartDataLabels);
const DiamondSizeIndComp = () => {
  const { t } = useTranslation();
  const DiamondSizeChartRef = useRef();
  const [tableKey, setTableKey] = useState(true);
  /*Initial State for Binding Starts*/
  const initialGlobalDiamondState = {
    dataRangeFrom: moment().subtract(30, "days").format("YYYY-MM-DD"),
    dataRangeTo: moment().format("YYYY-MM-DD"),
    SelectedDiamondValue: "All",
    retailerIds: [],
    vendorIds: [],
  };
  /*Initial State for Binding Ends*/
  /*React Binding Starts*/
  const [TableForAllList, setTableForAllList] = useState([]);
  const [globalDiamonds, setGlobalDiamond] = useState(
    initialGlobalDiamondState
  );
  const [LoadChartReportsLoading, setLoadChartReportsLoading] = useState(false);
  const [TableForAllLoading, setTableForAllLoading] = useState(false);
  const [TotalDiamondClicks, setTotalDiamondClicks] = useState(0);
  const [dealerId, setDealerId] = useState();
  const [forDealer, setForDealer] = useState("");
  const loginDetials = useSelector((state) => state.loginReducer);
  const [diamondSizeSearchesLabels, setdiamondSizeSearchesLabels] = useState(
    []
  );
  const [DiamondSizeYAxisList, setDiamondSizeYAxisList] = useState([]);
  const [totalValueForPercentage, setTotalValueForPercentage] = useState(0);
  const [TooltipPercentage, setTooltipPercentage] = useState("");
  const [TableShapeValue, setTableShapeValue] = useState("");
  const [TableClarityValue, setTableClarityValue] = useState("");
  const [TableCutGradeValue, setTableCutGradeValue] = useState("");
  const [TableColorValue, setTableColorValue] = useState("");
  const [TableSizeValue, setTableSizeValue] = useState("");
  const [TableCertificateValue, setTableCertificateValue] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [totalCount, setTotalCount] = useState(0);
  const [sortType, setSortType] = useState("desc");
  const [sortColumnName, setSortColumnName] = useState("GT.MODIFIED");
  const [IsReportEmpty, setIsReportEmpty] = useState(true);
  const [key, setKey] = useState(true);
  const [downloadCSVDataloading, setDownloadCSVDataloading] = useState(false);

  // New state for custom legends and max entries
  const [chartData, setChartData] = useState([]);
  const [colorData, setColorData] = useState([]);
  const [processedSizeLabels, setProcessedSizeLabels] = useState([]);
  const [processedSizeCounts, setProcessedSizeCounts] = useState([]);

  // Configuration
  const MAX_ENTRIES = 15; // Maximum slices to show

  /*React Binding Ends*/

  /*DatePicker Binding Starts*/
  const onDateChange = (dates, dateStrings) => {
    //
    if (dates) {
      //
      setGlobalDiamond((prevState) => ({
        ...prevState,
        dataRangeFrom: dateStrings[0],
        dataRangeTo: dateStrings[1],
      }));
    }
  };
  /*DatePicker Binding Ends*/
  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleCheckDealermembers(
            loginDetials.loginDetials.responseData.dealerId
          );
        }
      }
    }
  }, []);

  useEffect(() => {
    if (TableSizeValue) {
      setTableKey(!tableKey);
      setPageSize(15);
      handleGetDiamondReportForTableChartAll(dealerId, forDealer);
    }
  }, [TableSizeValue]);

  // Process chart data with max entries limit
  const processChartData = (sizes, counts) => {
    if (!sizes?.length || !counts?.length || sizes.length !== counts.length) {
      return { chartData: [], colors: [], processedLabels: [], processedCounts: [] };
    }

    // Combine sizes and counts into objects
    const combinedData = sizes.map((size, index) => ({
      size,
      count: counts[index],
      originalIndex: index
    }));

    // Filter out zero values and sort by count (descending)
    const filteredData = combinedData.filter(item => item.count > 0);
    const sortedData = [...filteredData].sort((a, b) => b.count - a.count);

    // Apply max entries limit
    const topData = sortedData.slice(0, MAX_ENTRIES);
    const remainingData = sortedData.slice(MAX_ENTRIES);

    // Calculate "Others" if needed
    const othersValue = remainingData.reduce((sum, item) => sum + item.count, 0);
    if (othersValue > 0 && remainingData.length > 0) {
      topData.push({
        size: t("Others"),
        count: othersValue,
        isOthers: true
      });
    }

    // Calculate total for percentages
    const total = topData.reduce((sum, item) => sum + item.count, 0);

    // Prepare chart data
    const processedChartData = [["Size", "Count"]];
    const colors = [];
    const processedLabels = [];
    const processedCounts = [];

    topData.forEach((item, index) => {
      const percentage = total > 0 ? ((item.count / total) * 100).toFixed(1) : 0;
      const color = chartColors[index % chartColors.length];
      colors.push(color);

      // For Google Charts with percentage in label
      processedChartData.push([`${item.size} (${percentage}%)`, item.count]);

      // Store processed data for other uses
      processedLabels.push(item.size);
      processedCounts.push(item.count);
    });

    return {
      chartData: processedChartData,
      colors,
      processedLabels,
      processedCounts
    };
  };

  /*API Binding Starts*/
  const handleCheckDealermembers = (id) => {
    let inputData = {
      dealerID: id,
    };

    GlobalDiamondReportService.CheckDealermembers(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        var forDealer = responseData.forDealer;
        if (message === "Success") {
          if (Object.keys(responseData).length !== 0) {
            setForDealer(forDealer);
          } else {
            setForDealer("");
          }
          handleLoadChartReports(id, forDealer);
          handleGetDiamondReportForTableChartAll(
            id,
            forDealer,
            pageNo,
            pageSize,
            sortColumnName,
            sortType
          );
        } else {
          setForDealer("");
        }
      })
      .catch((error) => {
        setForDealer("");
      });
  };

  const handleLoadChartReports = (dealerId, forDealer) => {
    let inputData = {
      dealerID: dealerId.toString(),
      forDealer: forDealer ? forDealer.toString() : "",
      fromDate: globalDiamonds.dataRangeFrom
        ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
        : "2020-08-17",
      toDate: globalDiamonds.dataRangeTo
        ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
        : "2022-09-15",
      retailerIds: globalDiamonds.retailerIds.toString(),
      vendorIds: globalDiamonds.vendorIds.toString(),
      selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
      type: "",
      reportName: "Size",
    };
    setLoadChartReportsLoading(true);

    GlobalDiamondReportService.LoadChartReports(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        var DiamondSizeSearchesList = responseData.DiamondSizeSearches;
        var TotalDiamondClicks =
          responseData.TotalDiamondClicks[0].TotalClickCnt;
        if (message === "Success") {
          if (Object.keys(responseData).length !== 0) {
            //
            setTotalDiamondClicks(TotalDiamondClicks);
            if (
              responseData.DiamondSizeSearches.every((item) => {
                return item.CNT == 0;
              })
            ) {
              setIsReportEmpty(true);
            } else {
              setIsReportEmpty(false);
            }
            var DiamondSizeSearchesLabelArr = DiamondSizeSearchesList.map(
              (item) => {
                return item.Size;
              }
            );
            setdiamondSizeSearchesLabels(DiamondSizeSearchesLabelArr);
            var DiamondSizeYAxisList = DiamondSizeSearchesList.map((item) => {
              return item.CNT;
            });
            setDiamondSizeYAxisList(DiamondSizeYAxisList);
            var totalValueForPercentage = DiamondSizeYAxisList.reduce(
              (a, b) => a + b,
              0
            );
            setTotalValueForPercentage(totalValueForPercentage);

            // Process data with max entries limit
            const {
              chartData: processedChartData,
              colors,
              processedLabels,
              processedCounts
            } = processChartData(DiamondSizeSearchesLabelArr, DiamondSizeYAxisList);

            setChartData(processedChartData);
            setColorData(colors);
            setProcessedSizeLabels(processedLabels);
            setProcessedSizeCounts(processedCounts);

            setKey(!key);
          }
        } else {
          setTotalDiamondClicks(0);
          setDiamondSizeYAxisList([]);
          setIsReportEmpty(false);
          setChartData([]);
          setColorData([]);
        }
      })
      .catch((error) => {
        setTotalDiamondClicks(0);
        setDiamondSizeYAxisList([]);
        setLoadChartReportsLoading(false);
        setdiamondSizeSearchesLabels([]);
        setIsReportEmpty(false);
        setChartData([]);
        setColorData([]);
      })
      .finally(() => {
        setLoadChartReportsLoading(false);
      });
  };

  const handleExportToCSV = (sortColumn, sorttype) => {
    try {
      let inputData = {
        dealerID: dealerId.toString(),
        forDealer: forDealer ? forDealer.toString() : "",
        fromDate: globalDiamonds.dataRangeFrom
          ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
          : "2020-08-17",
        toDate: globalDiamonds.dataRangeTo
          ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        clarity: TableClarityValue,
        cutGrade: TableCutGradeValue,
        shape: TableShapeValue,
        color: TableColorValue,
        size: TableSizeValue,
        certificate: TableCertificateValue,
        selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
        pageNumber: pageNo ? pageNo : 1,
        pageSize: pageSize ? pageSize : 15,
        sortOrderCol: sortColumnName || "GT.MODIFIED",
        sortOrderType: "ASC",
        reporttype: "Global",
        reportName: "Size",
      };
      setDownloadCSVDataloading(true);
      ReportsDiamondService.ExportDataToCSV(inputData)
        .then((response) => {
          setDownloadCSVDataloading(false);
          var fileName =
            "Global_DiamondSize_Report_" +
            new Date().toJSON().slice(0, 10).split("-").slice(1).concat(new Date().toJSON().slice(0, 4)).join("_") +
            ".csv";
          BlobToDownloadFile(response.data, fileName);
        })
        .catch((error) => {
          setDownloadCSVDataloading(false);
        });
    } catch (error) {
      setDownloadCSVDataloading(false);
    }
  };
  const handleGetDiamondReportForTableChartAll = (
    dealerId,
    forDealer,
    pageNo,
    pageSize,
    sortColumnName,
    sortOrder,
    sizeValue
  ) => {
    let inputData = {
      dealerID: dealerId.toString(),
      forDealer: forDealer ? forDealer.toString() : "",
      fromDate: globalDiamonds.dataRangeFrom
        ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
        : "2020-08-17",
      toDate: globalDiamonds.dataRangeTo
        ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
        : "2022-09-15",
      clarity: TableClarityValue,
      cutGrade: TableCutGradeValue,
      shape: TableShapeValue,
      color: TableColorValue,
      size: sizeValue ? sizeValue : TableSizeValue,
      certificate: TableCertificateValue,
      selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
      pageNumber: pageNo ? pageNo : 1,
      pageSize: pageSize ? pageSize : 15,
      sortOrderCol: sortColumnName || "GT.MODIFIED",
      sortOrderType: sortOrder || "DESC",
      reporttype: "Global",
      reportName: "Size",
    };
    setTableForAllLoading(true);
    ReportsDiamondService.GetDiamondReportForTableChartAll(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        var TableForAllList = responseData.modelTableChartAllList;
        var TotalEventsCount = responseData.totalCount;
        if (message === "Success") {
          if (
            responseData?.modelTableChartAllList &&
            responseData?.modelTableChartAllList !== null
          ) {
            if (Object.keys(responseData).length !== 0) {
              setTotalCount(TotalEventsCount);
              setTableForAllList(TableForAllList);
              setTableForAllLoading(false);
            }
          } else {
            setTotalCount(0);
            setTableForAllList([]);
            setTableForAllLoading(false);
          }
        } else {
          setTotalCount(0);
          setTableForAllList([]);
          setTableForAllLoading(false);
        }
      })
      .catch((error) => {
        setTotalCount(0);
        setTableForAllList([]);
        setTableForAllLoading(false);
      })
      .finally(() => setTableForAllLoading(false));
  };
  const handleTableASCDES = (pagination, filters, sorter) => {
    var tableBody = document.querySelector(".pendjewelreq__tbl .ant-table-body"); if (tableBody) tableBody.scrollTop = 0;
    var type = "";
    var column = "";
    //sorting
    if (sorter.order == "descend") {
      type = "DESC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else if (sorter.order == "ascend") {
      type = "ASC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else {
      type = "DESC";
      column = "GT.MODIFIED";
      setSortColumnName(column);
      setSortType(type);
    }
    setPageNo(pagination.current);
    setPageSize(pagination.pageSize);
    handleGetDiamondReportForTableChartAll(
      dealerId,
      forDealer,
      pagination.current,
      pagination.pageSize,
      column,
      type
    );
  };
  /*API Binding Ends*/
  const handleOnChange = (e, isSelect, name) => {
    setGlobalDiamond({
      ...globalDiamonds,
      [name]: e,
    });
  };

  const handleApplyFilter = () => {
    setTableKey(!tableKey);
    setPageSize(15);
    setTableSizeValue("");
    handleLoadChartReports(dealerId, forDealer);
    handleGetDiamondReportForTableChartAll(
      dealerId,
      forDealer,
      1,
      15,
      "GT.MODIFIED",
      "DESC",
      ""
    );
  };

  const chartOptions = {
    is3D: true,
    chartArea: { width: "100%", height: "100%" },
    legend: {
      position: "none", // Remove default legend since we have custom one
    },
    tooltip: { trigger: "focus" },
    pieSliceText: "percentage",
    pieSliceTextStyle: {
      color: "white",
      fontSize: 12,
    },
  };

  const handleClick = ({ chartWrapper }) => {
    const chart = chartWrapper.getChart();
    const selection = chart.getSelection();
    if (selection.length > 0) {
      const selectedItem = selection[0];
      const label = chartData[selectedItem.row + 1][0];
      const result = label.split(" (")[0];

      // Handle "Others" selection
      if (result === t("Others")) {
        // You might want to handle "Others" selection differently
        // For now, let's clear the size filter when "Others" is selected
        setTableSizeValue("");
        return;
      }

      setTableSizeValue(result);
    }
  };

   const handleDownloadPieChart = async () => {
     try {
       // Step 1: Prepare PDF-specific PieChart options
       const pdfChartOptions = {
         ...chartOptions,
         width: 1800,
         height: 850,
         chartArea: { left: 50, top: 20, width: "90%", height: "85%" },
         legend: { position: "none" }, // we'll add custom legend manually
         pieHole: 0.4,
         pieSliceText: "percentage",
         tooltip: { text: "percentage" },
         pieSliceTextStyle: { fontSize: 18, color: "#000" },
         colors: colorData, // Use same colors as legend
       };
 
       // Step 2: Create a hidden container
       const hiddenContainer = document.createElement("div");
       hiddenContainer.id = "pdf-temp-piechart";
       hiddenContainer.style.position = "absolute";
       hiddenContainer.style.left = "-9999px";
       hiddenContainer.style.top = "0";
       hiddenContainer.style.width = "1800px";
       hiddenContainer.style.background = "#fff";
       hiddenContainer.style.padding = "20px";
       document.body.appendChild(hiddenContainer);
 
       // Step 3: Create dynamic custom legends
       const legendDiv = document.createElement("div");
       legendDiv.style.display = "flex";
       legendDiv.style.flexWrap = "wrap";
       legendDiv.style.justifyContent = "space-evenly";
       legendDiv.style.marginBottom = "20px";
       legendDiv.style.fontFamily = "Arial, sans-serif";
       legendDiv.style.width = "100%";
 
       chartData.slice(1).forEach((row, index) => {
         const item = document.createElement("div");
         item.style.display = "flex";
         item.style.alignItems = "center";
         item.style.margin = "8px 16px";
         item.style.fontSize = "18px";
         item.style.fontWeight = "bold";
         item.style.whiteSpace = "nowrap";
 
         const colorBox = document.createElement("div");
         colorBox.style.width = "18px";
         colorBox.style.height = "18px";
         colorBox.style.backgroundColor = colorData[index];
         colorBox.style.marginRight = "8px";
         colorBox.style.border = "1px solid #aaa";
         colorBox.style.borderRadius = "3px";
 
         const labelText = row[0].replace(/\s*\([^)]*\)\s*/g, "");
         const valueText = ` (${row[1]})`;
 
         const textNode = document.createTextNode(labelText + valueText);
         item.appendChild(colorBox);
         item.appendChild(textNode);
         legendDiv.appendChild(item);
       });
 
       hiddenContainer.appendChild(legendDiv);
 
       // Step 4: Add chart container
       const chartDiv = document.createElement("div");
       chartDiv.style.width = "1800px";
       chartDiv.style.height = "850px";
       hiddenContainer.appendChild(chartDiv);
 
       // Step 5: Draw the pie chart in the hidden div
       const tempChart = new window.google.visualization.PieChart(chartDiv);
       const dataTable = window.google.visualization.arrayToDataTable(chartData);
       await new Promise((resolve) => {
         window.google.visualization.events.addListener(tempChart, "ready", resolve);
         tempChart.draw(dataTable, pdfChartOptions);
       });
 
       // Step 6: Capture legend + chart together
       const canvas = await html2canvas(hiddenContainer, {
         useCORS: true,
         scale: 2.8,
         logging: false,
       });
       const imgData = canvas.toDataURL("image/png");
 
       // Step 7: Clean up
       document.body.removeChild(hiddenContainer);
 
       // Step 8: Build PDF structure
       const pdf = new jsPDF({
         orientation: "landscape",
         unit: "mm",
         format: "a4",
       });
 
       const pageWidth = pdf.internal.pageSize.getWidth();
       const pageHeight = pdf.internal.pageSize.getHeight();
       const margin = 5;
       const headerHeight = 14;
       const footerHeight = 10;
       const infoBlockHeight = 20;
       const availableHeight =
         pageHeight - headerHeight - footerHeight - infoBlockHeight - 12;
 
       // Header
       pdf.setFillColor(31, 38, 62);
       pdf.rect(0, 0, pageWidth, headerHeight, "F");
       try {
         pdf.addImage(logoImg, "PNG", margin, 4, 40, 10);
       } catch { }
 
       pdf.setFont("helvetica", "bold");
       pdf.setFontSize(14);
       pdf.setTextColor(255, 255, 255);
       pdf.text("DIAMOND SIZE REPORT", pageWidth - margin, 11, { align: "right" });
 
       // Info Line (flex-like in one line)
        pdf.setFont("helvetica", "normal");
      pdf.setFontSize(9);
      pdf.setTextColor(0, 0, 0);

      const preparedFor =
        loginDetials?.impresonateData
          ? `Prepared For: ${loginDetials.impresonateData.username} (${loginDetials.impresonateData.dealerID})`
          : loginDetials?.loginDetials?.responseData
            ? `Prepared For: ${loginDetials.loginDetials.responseData.dealerCompany} (${loginDetials.loginDetials.responseData.dealerId})`
            : "Prepared For: -";

      const dateRange = `Date Range: ${moment(globalDiamonds.dataRangeFrom).format(
        "MMM DD, YYYY"
      )} - ${moment(globalDiamonds.dataRangeTo).format("MMM DD, YYYY")}`;

      const selectedDiamondLabel =
        globalDiamonds.SelectedDiamondValue === "All"
          ? "All Diamonds"
          : globalDiamonds.SelectedDiamondValue === "Mined"
            ? "Mined Diamonds"
            : "Lab Grown Diamonds";

      const diamondType = `Selected Diamond: ${selectedDiamondLabel}`;
      const clicks = `Total Clicks: ${TotalDiamondClicks?.toLocaleString() || 0}`;

      const infoLinesRaw = [
        preparedFor,
        dateRange,
        diamondType,
        clicks
      ].filter(Boolean);

      const maxWidth = pageWidth - margin * 2;

      // Split text dynamically to fit within the maxWidth
      const wrappedInfoLines = infoLinesRaw.flatMap((line) =>
        pdf.splitTextToSize(line, maxWidth)
      );

      const lineHeight = 4.8;
      let currentY = headerHeight + 5;

      // Display each line with proper spacing
      wrappedInfoLines.forEach((line) => {
        pdf.text(line, margin, currentY);
        currentY += lineHeight;
      });

      currentY += 4;
 
       // Chart Image
       const imgRatio = canvas.width / canvas.height;
       let imgWidthMM = pageWidth - margin * 3;
       let imgHeightMM = imgWidthMM / imgRatio;
       if (imgHeightMM > availableHeight) {
         imgHeightMM = availableHeight;
         imgWidthMM = imgHeightMM * imgRatio;
       }
 
       const xPos = margin;
       const yPos = currentY; 
       pdf.addImage(imgData, "PNG", xPos, yPos, imgWidthMM, imgHeightMM, undefined, "FAST");
 
       // Footer
       pdf.setFillColor(31, 38, 62);
       pdf.rect(0, pageHeight - footerHeight, pageWidth, footerHeight, "F");
       pdf.setTextColor(255, 255, 255);
       pdf.setFont("helvetica", "italic");
       pdf.setFontSize(8);
       const footerText = `© ${new Date().getFullYear()} JewelCloud Inc. | Generated on ${moment().format(
         "MMM DD, YYYY h:mm A"
       )}`;
       pdf.text(footerText, pageWidth / 2, pageHeight - footerHeight / 2 + 2, {
         align: "center",
       });
 
       // --- WATERMARK ---
       const watermarkText = "JewelCloud";
       pdf.setFontSize(90);
       pdf.setFont(undefined, "bolditalic");
       pdf.setTextColor(102, 102, 102);
 
       pdf.saveGraphicsState();
       pdf.setGState(pdf.GState({ opacity: 0.1 }));
 
       const centerX = pageWidth / 2;
       const centerY = pageHeight / 2;
 
       const textWidth = pdf.getTextWidth(watermarkText);
       const textHeight =
         pdf.internal.getFontSize() / pdf.internal.scaleFactor;
 
       const angleRad = (45 * Math.PI) / 180;
       const rotatedWidth =
         textWidth * Math.cos(angleRad) + textHeight * Math.sin(angleRad);
       const rotatedHeight =
         textWidth * Math.sin(angleRad) + textHeight * Math.cos(angleRad);
 
       const xPosWatermark = centerX - rotatedWidth / 2;
       const yPosWatermark = centerY + rotatedHeight / 4 + 40;
 
       pdf.text(watermarkText, xPosWatermark, yPosWatermark, { angle: 45 });
 
       pdf.restoreGraphicsState();
 
       pdf.save("Diamond-Size-Search-Report.pdf");
 
     } catch (err) {
       console.error("Error generating Pie Chart PDF:", err);
     }
   };

  return (
    <React.Fragment>
      <div className="form__fields magento__mapping">
        <div className="row">
          <div className="col-lg-12">
            <div className="heading__block">
              <h4 class="workarea__heading mt-0 mb-0">
                {t("Diamond Size Searches")}
              </h4>
            </div>
          </div>
          <div className="col-md-4">
            <div className="input__block dataRange-input-block datepicker__block">
              <label> {t("Date Range")} </label>
              <RangePicker
                className="date-range-input"
                ranges={{
                  Today: [moment(), moment()],
                  Yesterday: [
                    moment().subtract(1, "days"),
                    moment().subtract(1, "days"),
                  ],
                  "Last 7 Days": [moment().subtract(7, "days"), moment()],
                  "Last 30 Days": [moment().subtract(30, "days"), moment()],
                  "This Month": [
                    moment().startOf("month"),
                    moment().endOf("month"),
                  ],
                  "Last Month": [
                    moment().subtract(1, "month").startOf("month"),
                    moment().subtract(1, "months").endOf("month"),
                  ],
                  "Last 90 Days": [moment().subtract(90, "days"), moment()],
                  "Year To Date": [moment().startOf("year"), moment()],
                }}
                format={"MM-DD-YYYY"}
                onChange={onDateChange}
                defaultValue={[moment().subtract(30, "days"), moment()]}
                defaultPickerValue={[moment().subtract(30, "days"), moment()]}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="input__block">
              <label> {t("Select Diamond")} </label>
              <Select
                className="border__grey"
                placeholder={t("All")}
                showSearch
                name="SelectedDiamondValue"
                optionFilterProp="children"
                value={
                  globalDiamonds.SelectedDiamondValue
                    ? globalDiamonds.SelectedDiamondValue
                    : null
                }
                onChange={(e) =>
                  handleOnChange(e, "select", "SelectedDiamondValue")
                }
              // onSearch={onSearch}
              >
                <Option value="All">{t("All")}</Option>
                <Option value="Mined">{t("Mined Diamond")}</Option>
                <Option value="Lab">{t("Lab Grown Diamond")}</Option>
              </Select>
            </div>
          </div>

          {chartData.length > 1 && TableForAllList && TableForAllList.length > 0 && (
            <div className="col-lg-12 col-md-6 mt-4">
              <div className="input__block">
                <label>
                  <Spin spinning={LoadChartReportsLoading} size="small">
                    <b>
                      {" "}
                      {t("Total Clicks")} :{" "}
                      {TotalDiamondClicks ? TotalDiamondClicks : 0}
                    </b>
                  </Spin>
                </label>
              </div>
            </div>
          )}

          <div className="col-md-12 mt-2">
            <div className="button__block mb-4">
              <button className="primary-btn mr-2" onClick={handleApplyFilter}>
                {" "}
                {t("Apply Filter")}{" "}
              </button>
            </div>
          </div>
          <div
            className="chart__section"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Spin spinning={LoadChartReportsLoading} size="large">
              {chartData.length > 1 && TableForAllList && TableForAllList.length > 0 ? (
                <div id="pdf-content">
                  {/* Custom Legend */}
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "center",
                      marginBottom: "10px",
                    }}
                  >
                    {chartData.slice(1).map((row, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          margin: "4px 8px",
                          fontSize: "13px",
                          fontWeight: "500",
                        }}
                      >
                        <div
                          style={{
                            width: "14px",
                            height: "14px",
                            backgroundColor: colorData[index],
                            marginRight: "6px",
                            borderRadius: "3px",
                          }}
                        ></div>
                        {row[0].replace(/\s*\([^)]*\)\s*/g, "")} ({row[1]})
                      </div>
                    ))}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",

                    }}
                  >
                    {/* Pie Chart */}
                    <Chart
                      chartType="PieChart"
                      width={window.innerWidth > 500 ? 800 : 300}
                      height={window.innerWidth > 500 ? 500 : 300}
                      data={chartData}
                      options={{...chartOptions, colors: colorData}}
                      chartEvents={[
                        {
                          eventName: "select",
                          callback: handleClick,
                        },
                      ]}
                    />
                  </div>
                </div>
              ) : (
                <div className="no-report-render">
                  <div className="desc-space">
                    <h4 className="text-center">{t("No Data Found")}</h4>
                  </div>
                </div>
              )}
            </Spin>
          </div>

          <div className="col-lg-12 mt-3 d-flex flex-column flex-lg-row justify-content-lg-end mb-3">
            {chartData.length > 1 && (
              <Button className="primary-btn mb-2 mb-lg-0 mr-2" onClick={handleDownloadPieChart}>
                {" "}
                <i className="fa fa-download"></i> {t("Download Chart")}
              </Button>
            )}
            <Button
              className="primary-btn"
              onClick={() => handleExportToCSV()}
              loading={downloadCSVDataloading}
            >
              <i className="fa fa-download"></i> {t("Download CSV")}
            </Button>
          </div>

          <div className="col-lg-12 col-md-12">
            <Table
              key={tableKey}
              className="pendjewelreq__tbl"
                scroll={{ y: "calc(100vh - 340px)" }}
              loading={TableForAllLoading}
              columns={[
                {
                  title: (
                    <Tooltip title={t("UserIPAddress")}>
                      {t("UserIPAddress")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "usersIPAddress",
                  sorter: (a, b) => { },
                },
                {
                  title: <Tooltip title={t("Date")}>{t("Date")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "date",
                  key: "GT.MODIFIED",
                  defaultSortOrder: "descend",
                  sorter: (a, b) => { },
                  render: (item, row) => {
                    return moment(row.date).format("MM-DD-YYYY, hh:mm:ss A");
                  },
                },
                {
                  title: <Tooltip title={t("Shape")}>{t("Shape")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "shape",
                  sorter: (a, b) => { },
                },
                {
                  title: <Tooltip title={t("Size")}>{t("Size")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "size",
                  sorter: (a, b) => { },
                },
                {
                  title: <Tooltip title={t("Color")}>{t("Color")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "color",
                  sorter: (a, b) => { },
                },
                {
                  title: <Tooltip title={t("Cut")}>{t("Cut")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "cutGrade",
                  sorter: (a, b) => { },
                },
                {
                  title: <Tooltip title={t("Clarity")}>{t("Clarity")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "clarity",
                  sorter: (a, b) => { },
                  render: (row, item) => {
                    //
                    if (item.clarity) {
                      return (
                        <React.Fragment>
                          <span>{item.clarity}</span>
                        </React.Fragment>
                      );
                    }
                  },
                },
                {
                  title: (
                    <Tooltip title={t("Certificate")}>
                      {t("Certificate")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "certificate",
                  sorter: (a, b) => { },
                },
                {
                  title: (
                    <Tooltip title={t("RetailerPrice")}>
                      {t("RetailerPrice")}
                    </Tooltip>
                  ),
                  ellipsis: true,
                  dataIndex: "retailPrice",
                  sorter: (a, b) => { },
                  render: (row, item) => {
                    return (
                      <React.Fragment>
                        <span>
                          {item.retailPrice ? (
                            <span>
                              {/* {loginDetials.currency ? "" : "$"} */}
                              {item.retailPrice}
                            </span>
                          ) : (
                            "Call For Price"
                          )}
                        </span>
                      </React.Fragment>
                    );
                  },
                },
                {
                  title: <Tooltip title={t("Cost")}>{t("Cost")}</Tooltip>,
                  ellipsis: true,
                  dataIndex: "cost",
                  sorter: (a, b) => { },
                  render: (row, item) => {
                    return (
                      <React.Fragment>
                        <span>
                          {item.cost ? (
                            <span>
                              {/* {loginDetials.currency ? "" : "$"} */}
                              {item.cost}
                            </span>
                          ) : (
                            "Call For Price"
                          )}
                        </span>
                      </React.Fragment>
                    );
                  },
                },
              ]}
              dataSource={TableForAllList}
              pagination={{
                size: "small",
                total: totalCount,
                pageNo: pageNo,
                pageSize: pageSize,
                pageSizeOptions: [10, 15, 20, 50, 100],
                responsive: true,
                showSizeChanger: true,
              }}
              onChange={handleTableASCDES}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DiamondSizeIndComp;